import type { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const tripSubscriptionsRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./management/TripSubscriptionManagementRoute').then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/trips/subscriptions"
        linkText="Go back to trip subscriptions"
      />
    ),
  },
];
